<template>
  <screen
    v-show="show"
    :screen-info="$t('thingstonote.tie_hair')"
    :can-leave="false"
    @skip="$emit('skip')"
  >
    <div class="w-full" ref="animation"></div>
  </screen>
</template>

<script>
import autoNext from '@/mixins/auto-next';
import animation from '@/mixins/animation';
import tieHair from '@/assets/animations/tie_hair.json';
import Screen from '../common/Screen.vue';

export default {
  name: 'TieHair',
  components: {
    Screen,
  },
  mixins: [autoNext, animation],
  data: () => ({
    duration: 4.5,
    audioKey: '7-Tie_hair',
    animationData: tieHair,
  }),
};
</script>
